export default "__VITE_ASSET__BtaLinZW__"